<div
  class="scrollbar__wrapper"
  #scrollbarWrapper
  [style.width]="'calc(100% - ' + arrowLeft + 'px)'"
  (scroll)="onScroll($event)"
  (window:resize)="onResize()"
>
  <button
    class="scrollbar__arrow left"
    mat-button
    [style.left.px]="arrowLeft"
    *ngIf="childWidth > parentWidth"
    [ngClass]="{ invisible: scrollPosition === 0 }"
    (click)="moveScroll(false)"
    [intercomTarget]="'01-scrollbar-wrapper-40958'"
  >
    <fa-icon class="fs-07" [icon]="['fal', 'chevron-left']"></fa-icon>
  </button>
  <ng-content class="scrollbar__main-content"> </ng-content>
  <button
    class="scrollbar__arrow right"
    mat-button
    [style.right.px]="arrowRight"
    *ngIf="childWidth > parentWidth"
    [ngClass]="{ invisible: scrollPosition === maxScroll }"
    (click)="moveScroll(true)"
    [intercomTarget]="'01-scrollbar-wrapper-12205'"
  >
    <fa-icon class="fs-07" [icon]="['fal', 'chevron-right']"></fa-icon>
  </button>
</div>
